import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { Observable } from 'rxjs';
import { LoginService } from '../services/login.service';

@Injectable({
  providedIn: 'root'
})
export class RecoverPasswordResolver implements Resolve<boolean> {

  constructor(private service: LoginService) { }

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    return this.service.verifyTokenRecover(route.params.id);
  }
}